import React, { useEffect } from "react";
import image from "../assets/images/pictures/18w.jpg";
import {
  addDomainInImage,
  apiRequest,
  rankClassification,
} from "../core/utils";
import {
  handleResponseMessage,
  onChangeHandler,
} from "npm-solvitize/utils/Common";
import { homeApi, rankApi } from "../core/api_endpoints";
import { useAuth } from "../context/AuthContext";
import banner_image from "../assets/images/demo_banner.png";
import RankSkeleton from "../components/RankSkeleton";
import UserInfoCard from "../components/UserInfoCard";
import "../styles/Rank.css";
import Lottie from "lottie-react";
import { useLottie } from "lottie-react";

import ailoading from "../assets/lottie/Gift premium animation.json";
import ComingSoon from "./CommingSoon";

function Rank() {
  const { user } = useAuth();
  const home_data = {
    ranks: [],
    reward: null,
    my_rank: null,
  };
  const [data, setData] = React.useState(home_data);
  const [loading, setLoading] = React.useState(false);

  const { LottieView } = useLottie({
    animationData: ailoading,
    loop: true,
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async (page = 1) => {
    setLoading(true);
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    console.log("Fetching data for", month, year);

    let response = await apiRequest(`${homeApi}?page=${page}`, "GET", {
      order_month: month,
      order_year: year,
    });

    console.log("Main Response", response.data);

    if (response.status) {
      setLoading(false);
      setData(response.data);
      console.log("Data loaded successfully", response.data);
    }
    setLoading(false);
    let message = handleResponseMessage(response.status, response.message);
  };

  if (loading) {
    return <RankSkeleton />;
  }

  if (!data.reward?.prize && !loading) {
    return (
      <div className="empty-state d-flex flex-column align-items-center">
        <ComingSoon />
        {/* {LottieView} */}
        {/* <Lottie style={{ width: "100px", height: "100px" }} animationData={ailoading} loop={true} /> */}
      </div>
    );
  }


  return (
    <div className="rank-container">
      <div className="rank-content">
        <h1 className="rank-title">Monthly Championship Prize</h1>

        {data.reward ? (
          <img
            src={addDomainInImage(data.reward.prize)}
            alt="Prize Banner"
            className="prize-banner"
          />
        ) : (
          <h2>Contest is awaiting for this month</h2>
        )}

        <h2 className="rank-holders-title">Rank Holders</h2>

        {data.ranks.length ? (
          <div className="rank-holders-list">
            {data.ranks.slice(0, 3).map((holder) => {
              const { className, rank } = rankClassification(holder.rank);
              return (
                <div key={holder.id} className="rank-holder-card">
                  <h4 className="rank-holder-name">
                    {/* {holder.id}.  */}
                    {holder.name.toUpperCase()}
                  </h4>
                  <div className="rank-holder-info">
                    <span>{className}</span>
                    <div className="rank-badge">
                      <span className="rank-number">{rank}</span>
                    </div>
                  </div>
                </div>
              );
            })}
            {/* <span onClick={() => setShowAll(!showAll)}>
              {showAll ? "Show Less" : "Show More"}
            </span> */}
          </div>
        ) : (
          "Be the first, Start purchase to enter the leaderboard"
        )}

        {data.my_rank ? (
          <UserInfoCard
            myRank={data.my_rank}
            classified_rank={rankClassification(data.my_rank?.rank)}
          />
        ) : (
          <span className="user-journey-card">
            Your journey starts here 🚀 Make more purchase to claim your spot on
            the leaderboard!
          </span>
        )}
      </div>
    </div>
  );
}

export default Rank;
